import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import ReactQuill from 'react-quill';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';

const VacancyDetailModal = ({ data, open, close, className }) => {
  const [state, setState] = React.useState({
    companyName: '',
    locationName: '',
    data: '',
    jobPay: '',
    jobTitle: '',
    contract: '',
    img: '',
    seniority: '',
    carrer: [],
    isSingleCarrer: true,
    singleCarrer: '',
  });

  const formatDate = (date) => {
    return dayjs(date).format('DD.MM.YY');
  };

  React.useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      companyName: data.companyName,
      locationName: data.locationName,
      jobPay: data.jobPay,
      data: data.data,
      jobTitle: data.jobTitle,
      logo: data.logo,
      contract: data.contract,
      seniority: data.seniority,
      img: data.img,
    }));

    if (Array.isArray(data.carrer)) {
      data.carrer.forEach((c) => {
        setState((prevstate) => ({
          ...prevstate,
          isSingleCarrer: false,
          carrer: [...prevstate.carrer, c.value],
        }));
      });
    } else if (data.carrer) {
      setState((prevState) => ({
        ...prevState,
        isSingleCarrer: true,
        singleCarrer: 'Indiferente',
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        isSingleCarrer: true,
        singleCarrer: data.carrer,
      }));
    }
  }, [data]);

  if (!open) return null;

  return (
    <>
      <Dialog onClose={close} title="Detalles de la vacante">
        <div className={className}>
          <div className="jobContainer">
            <div
              className="jobImage"
              style={{
                backgroundImage: `url("${
                  state.img
                    ? state.img
                    : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fnegocio.png?alt=media&token=0e43774b-31b8-4393-bbe3-a6492da45174'
                }")`,
              }}
            />
            <section className="jobDescriptionRight">
              <header>
                <div className="jobHeaderContainerLeft">
                  {/*                  <img
                    src={
                      !!state.logo
                        ? state.logo
                        : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fnegocio.png?alt=media&token=0e43774b-31b8-4393-bbe3-a6492da45174'
                    }
                    alt=" | LaPieza.io"
                  /> */}
                  <h1>
                    {state.companyName} busca {state.jobTitle}
                  </h1>
                  <h6>
                    Ubicación: <b>{state.locationName === '' ? 'No especificado' : state.locationName}</b>
                  </h6>
                  <h6>
                    Contrato: <b> {state.contract}</b>
                  </h6>
                  <h6>{state.isSingleCarrer ? state.singleCarrer : state.carrer.toString()}</h6>
                  <h6>
                    Publicado: <b> {formatDate(state.postedFrom)}</b>
                  </h6>
                  <h6>
                    Nivel: <b>{state.seniority}</b>
                  </h6>
                  <h6>
                    Paga: <b>{state.jobPay || 'No especificado'}</b>
                  </h6>
                </div>
              </header>
              <div className="ql-editor">
                <article>
                  <ReactQuill value={state.data} readOnly theme="bubble" />
                </article>
              </div>
            </section>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default styled(VacancyDetailModal)`
  position: relative;
  margin: 10px auto;
  background-color: white;
  box-shadow: ${palette.lightBS};
  padding: 16px;
  outline: none;
  font-family: 'Sofia Pro', sans-serif;
  max-width: 768px;
  max-height: 90vh;
  .jobContainer {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }
  .jobImage {
    width: 100%;
    padding: 0px;
    margin: 0px;
    height: 300px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    &:after {
      position: absolute;
      backgroundcolor: rgb(25, 25, 25);
      content: ' ';
      opacity: 0.4;
      inset: 0px;
    }
  }
  .jobDescriptionRight {
    width: 100%;
    padding: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h1 {
    font-size: 2.8rem;
    text-align: start;
    margin-bottom: 14px;
    font-family: 'Cooper Md BT', serif;
  }
  header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  h6 {
    font-size: 16px;
    margin-bottom: 12px;
    text-align: center;
  }
  .jobHeaderContainerLeft {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 14px;
    img {
      width: 80px;
      height: 80px;
      object-fit: contain;
      border-radius: 50%;
      background-color: white;
    }
  }
  .jobHeaderContainerRight {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 14px;
  }
  .k-window-titlebar k-dialog-titlebar k-header {
    background-color: #0d5c1d !important;
  }
  .ql-editor {
    article {
      h1 {
        font-size: 36px;
        font-weight: 400;
      }
      h2 {
        font-size: 32px;
        font-weight: 400;
      }
      h3 {
        font-size: 26px;
        font-weight: 400;
      }
      p {
        font-size: 18px;
        line-height: calc(1ex / 0.25);
        font-family: 'Sofia Pro', sans-serif;
      }
      li {
        font-size: 16px;
        line-height: calc(1ex / 0.25);
        margin-top: 4px;
        font-family: 'Sofia Pro', sans-serif;
      }
      strong {
        font-family: 'Cooper Md BT', serif !important;
        font-size: 20px;
        p {
          font-family: 'Cooper Md BT', serif !important;
        }
      }
    }
  }
`;
